import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { weddingHallContract } from '@src/@slice/weddingHallContractSlice';
import BottomFixedModal from '@src/components/common/bottomFixedModal/BottomFixedModal';
import Ksnet from '@src/pages/ksnetPay/Ksnet';
import './finalContractInfoModal.scss';
import dayjs from 'dayjs';

const FinalContractInfoModal = ({isShow,price,closeModal,paymentMethod}) => {
    const weddingContractData =  useSelector(weddingHallContract).data.weddingContractData; // 예식계약서 정보들
    const {partnerName, individualHallName, weddingDate, weddingTime, guarantee} = weddingContractData
    
    return (
        <BottomFixedModal  isShow={isShow} title="" hideModal={closeModal}>
        {isShow && 
            <div className='contract-final-info-sheet'>
                <h2>{`마지막으로 주요\n계약내역을 확인해주세요.`}</h2>
                <div className='table-wrap'>
                    <table>
                        <tbody>
                            <tr>
                                <td>예식장소</td>
                                <td>{partnerName} {individualHallName}</td>
                            </tr>
                            <tr>
                                <td>예식일자</td>
                                <td>{dayjs(weddingDate.replaceAll('.','-')).format('YYYY년 MM월 DD일 ddd요일')} {weddingTime}</td>
                            </tr>
                            <tr>
                                <td>보증인원</td>
                                <td>최소 {guarantee}명</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Ksnet name={`계약금 ${price?.toLocaleString()}원 결제`} paymentMethod={paymentMethod}/>
            </div>       
        }
        </BottomFixedModal>
    );
};

export default FinalContractInfoModal;